<template>
  <MenuItems :items="menuItems"/>
</template>

<script>
import MenuItems from '../components/MenuItems.vue'
export default {
    components:{
        MenuItems
    },
    data: ()=>({
        menuItems: [
        {
            title: "Número de Radicación",
            icon: "fas fa-list-ol",
            url: "/Procesos/NumeroRadicacion",
        },
        {
            title: "Consultar por Nombre o Razón Social",
            icon: "fas fa-file-invoice",
            url: "/Procesos/NombreRazonSocial",
        },
        {
            title: "Construir Número",
            icon: "fas fa-chalkboard-teacher",
            url: "/Procesos/ConstruirNumeroRadicacion",
        },
        {
            title: "Consultar por Juez / Magistrado y Clase de Proceso",
            icon: "fas fa-user-tie",
            url: "/Procesos/Jueces",
        },
        {
            title: "Juzgados de Ejecución de Penas y Medidas de Seguridad",
            icon: "fas fa-gavel",
            url: "/Procesos/JuezClaseProceso",
        },
        {
            title: "Seguimiento de Procesos",
            icon: "fas fa-clipboard-check",
            url: "/Procesos/seguimiento-procesos",
            guards: ['SeguimientoProcs'],
        },
        {
            title: "Acceso CPNU (Admin)",
            icon: "fas fa-sign-in-alt",
            url: "/procesos/menu-acceso",
            guards: ['Admin'],
        },
        {
            title: "Consulta por identificación (CC / Nit / CE)",
            icon: "fas fa-address-card",
            url: "/Procesos/ConsultaIdentificacion",
            guards: ['VerCedulas'],
        },
        // {
        //   title: "Acceso a la Información",
        //   icon: "fas fa-scroll",
        //   url: "/Procesos/AccesoInformacion",
        //   guards: ['ResultSets'],
        ]        
    }),
}
</script>

<style>

</style>